export const VerificationType = {
  Email: "Email",
  Mobile: "Mobile",
  Both: "Both",
};
